import React from "react";
import { useTranslation } from "react-i18next";

const ProcessFinal = ({ doSetting, categories }) => {
	const { t } = useTranslation();
	return (
		<>
			<div className="side-content">
				<h3>{t("pages.apply.ApplySetting.ProcessingModal.Final")}</h3>
			</div>
			<section className="c__card">
				<div className="table-head">
					<div className="th main-category">
						{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.item")}
					</div>
					<div className="th sub-category">
						{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.evaluateitem")}
					</div>
					<div className="th weight">
						{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.ratio")}
					</div>
				</div>
				<ul className="setting-summary-table">
					{categories.map((d) => (
						<li className="tr" key={d.idx}>
							<div className="td main-category">{d.title}</div>
							<div className="td sub-category">
								{d.items.map((da, index) => (
									<p key={da.idx}>
										{index + 1}. {da.content}
									</p>
								))}

								{/* <p>2. test12</p> */}
							</div>
							{doSetting ? (
								<div className="td weight" data-unit="%">
									{d.weight}
								</div>
							) : (
								<div className="td weight" data-unit="%">
									{Number.isInteger(100 / categories.length)
										? 100 / categories.length
										: (100 / categories.length).toFixed(2)}
								</div>
							)}
						</li>
					))}
				</ul>
			</section>
		</>
	);
};

export default ProcessFinal;
